import React, {useContext } from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import AuthContext from "../context/AuthProvider";
import axios from "../api/axios";
import config from '../config/configJS';
import useAuth from "../hooks/useAuth";

import { useCreatingNewUserAtom } from '../atoms/users/useCreatingNewUserAtom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {useMsal} from "@azure/msal-react";

function UserMenu() {
  const { setAuth } = useContext(AuthContext);
  const { auth } = useAuth();
  const [, setCreatingNewUser] = useCreatingNewUserAtom();
  const [t,] = useTranslation('global');
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { instance } = useMsal();

  let userName = t('hello')+ ' ' + auth.ufn;
  let userIcon = auth.ufn.charAt(0)+auth.uln.charAt(0);

  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    let userAuthMethod = auth.uam;

    setAnchorEl(null);
    setAuth({});
    
    axios.post(config.endPoint + "/api/auth/LogOut", {}, { withCredentials: true })
      .then(async () => {
      if (!!instance) {
        if (userAuthMethod == "ad") {
          console.log('logging out');
          await instance.logoutPopup()
        } 
      }

      navigate('/Login');
    }).catch((error) => {
      console.log(error);
    });
  };


  const handleShowUsers = () => {
    setAnchorEl(null);
    setCreatingNewUser(true);
    navigate('/Users');
  };

  const handleSettings = () => {
    setAnchorEl(null);
    //setCreatingNewUser(true); co je toto
    navigate('/Settings');
  };

  const handleManageDocuments = () => {
    setAnchorEl(null);
    navigate('/ManageDocuments');
  }

  const handleShowTeams = () =>{
    setAnchorEl(null);
    navigate('/Teams');
  }

  const customStyles = {
    cursor: 'default',
    opacity: '1 !important',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  };
  const logoutStyle = {
    color: "#d42a2f"
  };

  return (
    <div className='user-menu-button-wrap'>    

        <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
        >
            <Avatar sx={{ width: 32, height: 32 }}>{userIcon}</Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0.1px 0.1em 1em rgba(0,0,0,0.2))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              }
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem sx={customStyles} disabled={true}>
            {userName}
          </MenuItem>

          <Divider />

          {auth.uri === 1 ? 
          <div>
            <MenuItem onClick={handleShowUsers}>
            <span className="material-symbols-outlined">group</span>
              {t('users')}
            </MenuItem>
            <MenuItem onClick={handleShowTeams}>
            <span className="material-symbols-outlined">workspaces</span>
              {t('teams')}
            </MenuItem>
            <MenuItem onClick={handleManageDocuments}>
              <span className="material-symbols-outlined">folder</span>
              {t('documents')}
            </MenuItem>
          </div> 
          : null }

          <MenuItem onClick={handleSettings}>
            <span className="material-symbols-outlined">settings</span>
            {t('settings')}
          </MenuItem>
          <MenuItem onClick={handleLogOut} sx={logoutStyle} className='logout-item'>
            <span className="material-symbols-outlined">logout</span>
            {t('logout')}
          </MenuItem>
        </Menu>
    </div>
  );
}

export default UserMenu;
